/* angular:styles/component:css;af02f1eb5d757e1fb3cfa60a8c434fe23638917f1cce02583bd7e6fd252555bd;/codebuild/output/src1273960344/src/smartdineuinew/src/app/common/components/help-support/help-support.component.ts */
.text-label {
  font: normal normal normal 14px/21px Chivo;
  color: #0089ff;
}
.fw-600 {
  font-size: 16px !important;
  font-weight: 600 !important;
}
ion-content {
  position: relative;
}
.close-icon {
  position: absolute;
  top: 10px;
  left: 10px;
}
::ng-deep .custom-popover {
  position: absolute !important;
  left: -250px !important;
  top: -50px !important;
  right: auto;
}
/*# sourceMappingURL=help-support.component.css.map */
